import React from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import {
  ExternalForwardFetalSexHeaderContainer,
  ExternalForwardFetalSexHeaderIconsLinksContainer,
  ExternalForwardFetalSexHeaderIconsContainer,
  ExternalForwardFetalSexHeaderIcon,
  ExternalRevealGrid,
  ExternalForwardFetalSexInfoWrapper,
} from "./ExternalForwardFetalSex.styles";
import unityLockup from "../../assets/logos/unity-rebrand/unity-horiz-cobranded-tint.svg";
import { ExternalFetalSexReveal } from "./ExternalFetalSexReveal";
import { GetTypographyContent } from "../shared/Typography/Typography";
import { getUserAuth } from "../../recoil/selectors";

const ExternalForwardFetalSex = (): React.ReactElement => {
  const auth = useRecoilValue(getUserAuth);
  const { t } = useTranslation();
  return (
    <>
      {!auth && (
        <ExternalForwardFetalSexHeaderContainer>
          <ExternalForwardFetalSexHeaderIconsLinksContainer>
            <ExternalForwardFetalSexHeaderIconsContainer>
              <ExternalForwardFetalSexHeaderIcon
                src={unityLockup}
                width="279px"
                alt="Unity by BillionToOne"
              />
            </ExternalForwardFetalSexHeaderIconsContainer>
          </ExternalForwardFetalSexHeaderIconsLinksContainer>
        </ExternalForwardFetalSexHeaderContainer>
      )}
      <ExternalForwardFetalSexInfoWrapper>
        <ExternalRevealGrid>
          {GetTypographyContent({
            content: t("fetalSex.external.resultsShow"),
            size: "h1",
            textColor: "greyMedium",
            padding: "0px 0px 0px 10px",
          })}
          <ExternalFetalSexReveal />
        </ExternalRevealGrid>
      </ExternalForwardFetalSexInfoWrapper>
    </>
  );
};
export default ExternalForwardFetalSex;
